<a class="skip-content-link skip-to-main-content" data-nosnippet fragment="main-content" [routerLink]="[]">{{
  'common.skip_to_main.link' | translate
}}</a>

<div
  [ngClass]="wrapperClasses$ | async"
  class="d-flex flex-column min-vh-100"
  [class.prs-app--auth]="authShell$ | async"
>
  @if ((authShell$ | async) !== true) {
  <div class="custom-header-box">
    <custom-header />
  </div>
  }

  <div class="wrapper" [class.prs-auth-wrapper]="authShell$ | async">
    <main
      class="main-container"
      [class.container]="(authShell$ | async) !== true"
      id="main-content"
      tabindex="-1"
    >
      <router-outlet />
    </main>
  </div>

  @if (authShell$ | async) {
  <ish-presidio-auth-footer />
  } @else {
  <footer class="mt-auto" data-testing-id="section-footer">
    <ish-presidio-storefront-footer />
  </footer>
  }
</div>

<ish-cookies-banner />

@if ((authShell$ | async) !== true) {
<ish-lazy-copilot />
<ish-presidio-quote-cart-sfl-modal />
}
